// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_kp-1";
export var quotedThread = "_kp-0";